var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t('components.fleet.FleetVehicleDetailDocumentCard.addDocumentDialogTitle'),
      "isDialogActive": _vm.dialogActive,
      "leftDisabled": _vm.isLoading,
      "rightDisabled": _vm.isRightDisabled,
      "rightLoading": _vm.isLoading,
      "leftText": _vm.$t('back'),
      "width": "800px"
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.dialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.dialogActive = $event;
      },
      "rightClick": _vm.rightClick,
      "leftClick": _vm.leftClick
    }
  }, [_c('paginated-table', {
    attrs: {
      "store": _vm.store,
      "predefinedFilter": _vm.store.commonPredefinedFilter,
      "selectedItems": _vm.selected,
      "baseQuery": {
        partnerId: _vm.partnerId
      },
      "showSelect": true,
      "headers": _vm.headers
    },
    on: {
      "update:selectedItems": function updateSelectedItems($event) {
        _vm.selected = $event;
      },
      "update:selected-items": function updateSelectedItems($event) {
        _vm.selected = $event;
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }